import { render, staticRenderFns } from "./select-team.vue?vue&type=template&id=0f4ea7c4&scoped=true&"
import script from "./select-team.vue?vue&type=script&lang=js&"
export * from "./select-team.vue?vue&type=script&lang=js&"
import style0 from "./select-team.vue?vue&type=style&index=0&id=0f4ea7c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4ea7c4",
  null
  
)

export default component.exports